import { getConnectCarrierKeyloakRoles } from '@app/auth/keycloak';
import { useMemo } from 'react';

// ts-unused-exports:disable-next-line
export enum Roles {
  Admin = 'connect-carrier-admin',
  Operations = 'connect-carrier-operations',
  ReadOnly = 'connect-carrier-read-only',
  Accounting = 'connect-carrier-accounting',
  Pricing = 'connect-carrier-pricing',
}

/** Checks if the user has the specified roles **/
// ts-unused-exports:disable-next-line
export const useHasRole = (role: Roles): boolean => {
  const roles: string[] | undefined = getConnectCarrierKeyloakRoles();
  return useMemo(() => {
    return roles ? roles.includes(role) : false;
  }, [roles, role]);
};

/** Checks if the user has any of the specified roles **/
// ts-unused-exports:disable-next-line
export const useHasAnyRole = (rolesToCheck: Roles[]): boolean => {
  const roles: string[] | undefined = getConnectCarrierKeyloakRoles();
  return useMemo(() => {
    if (!roles) {
      return false;
    }
    return rolesToCheck.some((role) => roles.includes(role));
  }, [roles, rolesToCheck]);
};
